import a from "../../share/apeiron/ApeironTextField.js";
import { t as e } from "i18next";
import { jsx as r } from "react/jsx-runtime";
const i = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/, m = (t) => /* @__PURE__ */ r(a, {
  ...t,
  rules: {
    required: !0,
    pattern: {
      value: i,
      message: e("account_setting.change_email_error")
    }
  },
  label: e("account_setting.change_email_label")
});
export {
  i as EmailValidationPattern,
  m as default
};
//# sourceMappingURL=EmailTextField.js.map
